import { Link, useParams } from "react-router-dom";
import { APP_ROUTES } from "../../routes";

export default function IntentPlanDetail() {
  const { id: projectId = "", planId = "" } = useParams<{
    id: string;
    planId: string;
  }>();

  return (
    <div className="manifold-page">
      <header className="manifold-page-header">
        <p className="sg-section-kicker">Pillar A · Intent Plan</p>
        <h1>Plan {planId}</h1>
        <p className="text-muted">
          Subgoals, referenced meshes from the world twin, agent rationale,
          and the ledger signature attached to this plan.
        </p>
      </header>

      <section className="manifold-empty">
        <h2>Plan detail view (placeholder)</h2>
        <p>
          The replay overlay (subgoal markers on the Three.js scene) and
          the signed disclosure block will render here once the
          Intelligence Core API ships.
        </p>
        <Link to={APP_ROUTES.intent(projectId)} className="sg-btn sg-btn-secondary">
          All plans
        </Link>
      </section>
    </div>
  );
}
